export enum PartnershipLabelEnumFR {
	REGION_OCCITANIE = 'REGION_OCCITANIE'
}

export enum PartnershipLabelEnum {
	OCCITANIA_DISTRICT = 'OCCITANIA_DISTRICT'
}

export const getPartnershipLabelFromFR = (
	e: PartnershipLabelEnumFR
): PartnershipLabelEnum | undefined => {
	if (e === PartnershipLabelEnumFR.REGION_OCCITANIE) {
		return PartnershipLabelEnum.OCCITANIA_DISTRICT;
	}
};
